module.exports = "/images/mandarin-conversation.jpg?6ed0da24f266f391862d7636b2e4a987";